import { TSupportMessage } from '@cannect/services/resources/supportChat/types'

/**
 * Depois deste intervalo, o bloco recomeça mesmo sendo a mesma pessoa.
 *
 * Sem isso, uma resposta que chega meia hora depois apareceria colada na
 * anterior, como se fosse a mesma fala.
 */
const BLOCK_BREAK_MS = 5 * 60 * 1000

/**
 * Diz se a mensagem abre um bloco — é o que decide se o nome do remetente
 * aparece, como no WhatsApp.
 */
export const startsNewBlock = (message: TSupportMessage, previous?: TSupportMessage) => {
  if (!previous) return true
  if (previous.sender_type !== message.sender_type) return true
  if (previous.sender_id !== message.sender_id) return true

  return message.created_at - previous.created_at > BLOCK_BREAK_MS
}

export default startsNewBlock
